import dayjs from 'dayjs';
import { CLIENT_DATE_FORMAT } from '../constants';

export const formatDateInput = (value: string): string => {
  const digits = value.replace(/\D/g, '').slice(0, 8);

  const d = digits.slice(0, 2);
  const m = digits.slice(2, 4);
  const y = digits.slice(4, 8);

  return [d, m, y].filter(Boolean).join('.');
};

export const isValidDateString = (value: string): boolean => {
  if (value.length !== 10) {
    return false;
  }

  return dayjs(value, CLIENT_DATE_FORMAT, true).isValid();
};
